<button class="mat-elevation-z" type="button" mat-mini-fab
	[title]="'INSERT_MACRO' | translate" [class.active]="suggestionsOpen" (click)="onSuggestionsButtonClick()">
	<i class="fas fa-code"></i>
</button>

<div *ngIf="suggestOptions?.length" class="suggestions" [hidden]="!suggestionsOpen">
	<bb-entity-selector [hideValue]="true" [theme]="theme" #suggestionES [(ngModel)]="suggestion" [options]="suggestOptions" [selectOnly]="true"
		(optionSelected)="suggestionSelected($event)" (closed)="suggestionsOpen = false" [ngModelOptions]="{standalone: true}"></bb-entity-selector>
</div>
